import { render, staticRenderFns } from "./ServiceAppOrderRequestList.vue?vue&type=template&id=63bd9987&scoped=true"
import script from "./ServiceAppOrderRequestList.vue?vue&type=script&lang=js"
export * from "./ServiceAppOrderRequestList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bd9987",
  null
  
)

export default component.exports